/* =========================================================================
   Place des Arts — Footer MOBILE (<750) : restructuration façon Figma 2025:110216.
   -------------------------------------------------------------------------
   Le footer natif range son contenu en 3 colonnes éditeur-owned (footer-group.json
   INTACT) : [newsletter + réseaux] · [certifiées + contacter] · [expertise + collaborer].
   Sur mobile, la maquette veut : Newsletter → 4 ACCORDÉONS FERMÉS (Des œuvres certifiées,
   Obtenir une expertise, Nous contacter, Collaborer) → Réseaux sociaux (en bas).

   On restructure en JS (les blocs sont des text-blocks génériques sans hook CSS stable) :
   on DÉPLACE chaque section (titre + corps) dans un conteneur mobile, dans l'ordre Figma,
   les 4 du milieu en <details> fermés. RÉVERSIBLE : on mémorise la position d'origine de
   chaque bloc et on restaure à l'identique si on repasse en desktop (≥750) → desktop intact.
   ========================================================================= */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 767px)'); // mobile <768 (rectification Sam 15/07)
  var CHEVRON =
    '<svg class="pda-footer-acc__chevron" width="9" height="5" viewBox="0 0 9 5" fill="none" aria-hidden="true"><path d="M1 1l3.5 3 3.5-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var built = false;
  var moved = []; // [{ el, parent, next }] pour restaurer
  var mobEl = null;
  var wrapperEl = null;

  function findWrapper() {
    var form = document.querySelector('footer email-signup-component, footer .email-signup-block');
    var section = form && form.closest('.section');
    return section && section.querySelector('.footer-content');
  }

  function headingText(b) {
    var h = b.querySelector('h1,h2,h3,h4,h5,h6');
    return h ? h.textContent.trim() : null;
  }

  function build() {
    if (built) return;
    var wrapper = findWrapper();
    if (!wrapper) return;
    wrapperEl = wrapper;

    // Blocs feuilles, dans l'ordre DOM, à travers les 3 groupes.
    var groups = Array.prototype.slice.call(wrapper.querySelectorAll(':scope > .group-block'));
    var blocks = [];
    groups.forEach(function (g) {
      var inner = g.querySelector('.group-block-content') || g;
      Array.prototype.slice.call(inner.children).forEach(function (b) {
        if (b.nodeType === 1) blocks.push(b);
      });
    });
    if (!blocks.length) return;

    // Regroupe en sections : chaque titre (h*) démarre une section, le reste = corps.
    var sections = [];
    blocks.forEach(function (b) {
      if (headingText(b)) sections.push({ title: headingText(b), header: b, body: [] });
      else if (sections.length) sections[sections.length - 1].body.push(b);
    });

    var norm = function (s) { return (s || '').toLowerCase(); };

    /* ⚡ 12/08 — IDENTIFIER PAR LA CLÉ DE RÉGLAGE, PAS PAR LE TITRE.
       Vécu : Sam a renommé « Obtenir une expertise » en « Vous souhaitez vendre une
       oeuvre ? » depuis l'éditeur, et la colonne a DISPARU du footer mobile — `find('expertise')`
       ne trouvait plus rien, et le `.filter(Boolean)` plus bas la retirait de l'ordre.
       Un titre est du CONTENU, éditable par le client à tout moment : le code ne doit pas en
       dépendre. Le thème émet des hooks id-stables `…__<clé JSON>` (ici `__expertise_title`) :
       on s'ancre là-dessus, et le titre ne sert plus que de repli pour les blocs éventuels
       qui n'auraient pas de clé. */
    var parCle = function (cle) {
      return sections.filter(function (s) {
        var el = s.header;
        return el && el.className && String(el.className).indexOf('__' + cle) !== -1;
      })[0];
    };
    var parTitre = function (frag) { return sections.filter(function (s) { return norm(s.title).indexOf(frag) !== -1; })[0]; };
    var find = function (cle, frag) { return parCle(cle) || parTitre(frag); };

    var newsletter = find('nl_title', 'newsletter');
    var cert = find('cert_title', 'certifi');
    var expertise = find('expertise_title', 'expertise');
    var contact = find('contact_title', 'contacter');
    var collab = find('collab_title', 'collabor');
    var social = parCle('social_title') || parTitre('réseaux') || parTitre('reseaux');

    var order = [newsletter, cert, expertise, contact, collab, social].filter(Boolean);
    if (!order.length) return;
    var accSet = [cert, expertise, contact, collab];

    // Mémorise la position d'origine de chaque bloc AVANT de déplacer.
    order.forEach(function (sec) {
      var all = (sec.header ? [sec.header] : []).concat(sec.body);
      all.forEach(function (el) { moved.push({ el: el, parent: el.parentNode, next: el.nextSibling }); });
    });

    // Construit le conteneur mobile.
    mobEl = document.createElement('div');
    mobEl.className = 'pda-footer-mobile';
    var accGroup = null;
    order.forEach(function (sec) {
      if (accSet.indexOf(sec) !== -1 && sec.header) {
        // Les 4 accordéons vont dans UN groupe (.pda-footer-acc-group, gap 32) —
        // créé à la 1re occurrence, réutilisé ensuite (Figma 2025:110320). Les sections
        // principales (newsletter/groupe/réseaux) gardent le gap 48 de .pda-footer-mobile.
        if (!accGroup) {
          accGroup = document.createElement('div');
          accGroup.className = 'pda-footer-acc-group';
          mobEl.appendChild(accGroup);
        }
        var det = document.createElement('details');
        det.className = 'pda-footer-acc';
        var sum = document.createElement('summary');
        sum.className = 'pda-footer-acc__sum';
        sum.appendChild(sec.header);
        sum.insertAdjacentHTML('beforeend', CHEVRON);
        det.appendChild(sum);
        var body = document.createElement('div');
        body.className = 'pda-footer-acc__body';
        sec.body.forEach(function (b) { body.appendChild(b); });
        det.appendChild(body);
        accGroup.appendChild(det);
      } else {
        var grp = document.createElement('div');
        grp.className = 'pda-footer-mobile__block';
        if (sec.header) grp.appendChild(sec.header);
        sec.body.forEach(function (b) { grp.appendChild(b); });
        mobEl.appendChild(grp);
      }
    });

    wrapper.appendChild(mobEl);
    wrapper.classList.add('pda-footer-content--mobile'); // masque les groupes vides, montre .pda-footer-mobile
    built = true;
  }

  function restore() {
    if (!built) return;
    // Remet chaque bloc à sa position d'origine (ordre inverse pour que `next` reste valide).
    for (var i = moved.length - 1; i >= 0; i--) {
      var m = moved[i];
      m.parent.insertBefore(m.el, m.next);
    }
    moved = [];
    if (mobEl && mobEl.parentNode) mobEl.parentNode.removeChild(mobEl);
    mobEl = null;
    if (wrapperEl) wrapperEl.classList.remove('pda-footer-content--mobile');
    built = false;
  }

  function sync() {
    if (MQ.matches) build();
    else restore();
  }

  /* ——— COLLABORER (tous viewports) : le bloc texte éditeur-owned (footer-group.json INTACT)
     porte « → Professionnel<br>→ Presse » en dur. Figma (I1979:144774;1979:100249) veut
     « Professionnel ↗ » / « Presse ↗ » : flèche 16 APRÈS le texte, gap 8 (CSS .pda-collab-row).
     Transformation d'AFFICHAGE idempotente (data-pda-collab) : « → » retirés, ↗ SVG ajouté
     par ligne. Ne cible que les <p> du footer dont le texte COMMENCE par « → ». ——— */
  var ARROW =
    '<svg class="pda-collab-row__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25H5.25C4.83579 3.25 4.5 3.58579 4.5 4C4.5 4.41421 4.83579 4.75 5.25 4.75H11.25V10.75C11.25 11.1642 11.5858 11.5 12 11.5C12.4142 11.5 12.75 11.1642 12.75 10.75V4ZM4 12L4.53033 12.5303L12.5303 4.53033L12 4L11.4697 3.46967L3.46967 11.4697L4 12Z" fill="currentColor"/></svg>';

  function collabArrows() {
    var footer = document.querySelector('footer');
    if (!footer) return;
    var ps = footer.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.getAttribute('data-pda-collab')) continue;
      if (!/^\s*→/.test(p.textContent)) continue;
      var frag = document.createDocumentFragment();
      var row = null;
      var appendArrow = function () {
        if (!row || !row.textContent.replace(/\s/g, '')) { row = null; return; }
        var tmp = document.createElement('span');
        tmp.innerHTML = ARROW;
        row.appendChild(tmp.firstChild);
        row = null;
      };
      var nodes = Array.prototype.slice.call(p.childNodes);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 1 && n.tagName === 'BR') {
          appendArrow();
          frag.appendChild(n);
        } else {
          if (!row) {
            row = document.createElement('span');
            row.className = 'pda-collab-row';
            frag.appendChild(row);
          }
          if (n.nodeType === 3) n.textContent = n.textContent.replace(/^\s*→\s*/, '');
          row.appendChild(n);
        }
      }
      appendArrow();
      p.appendChild(frag);
      p.setAttribute('data-pda-collab', '1');
    }
  }

  function init() {
    sync();
    collabArrows();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // matchMedia : (dé)construit uniquement au franchissement du breakpoint (pas à chaque resize).
  if (MQ.addEventListener) MQ.addEventListener('change', sync);
  else if (MQ.addListener) MQ.addListener(sync);
})();
